import { DateUtil } from '@/utils';
import mutations from './accKeyDetailsMutation';
import actions from './accKeyDetailsAction';
import getters from './accKeyDetailsGetter';

const state = {
  cnt: 0,
  gridData: {},
  searchParam: {
    divisionCode: '', // 사업부
    cspCode: '', // CSP
    accoutId: '', // Linked Account
    keyAge: '', // Key Age
    keyAgeComparison: '', // Key Age 비교 연산자
    batchDate: null, // 조회일자
    keyExcept: '', // 보안조치
    ipRestriction: '', // IP접근제어 여부
  },
  item: {},
  projectList: [],
};

export default {
  state,
  mutations,
  actions,
  getters,
  DateUtil,
};



// WEBPACK FOOTER //
// ./src/vuex/accKey/details/accKeyDetailsStore.js